/*
 * The Task Generation card's coverage notes, from the generation_config GET's
 * `rule_notes`.
 *
 * Its own tested helper rather than an inline map because index.jsx has no test
 * file: this is where the shape assumptions live (a plain object keyed by the
 * PRD's trigger name, values already full sentences) and where a server that
 * does not send the key yet has to degrade to rendering nothing.
 *
 * Keys are sorted so the order does not depend on JSON key order.
 */
const ruleNotesLines = (obj: unknown): string[] => {
  if (!obj || typeof obj !== 'object' || Array.isArray(obj)) return [];
  const notes = obj as Record<string, unknown>;
  return Object.keys(notes)
    .sort()
    .map((k) => notes[k])
    .filter((v): v is string => typeof v === 'string' && v.trim() !== '');
};

export default ruleNotesLines;
